import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import moment from 'moment-mini';

Vue.config.productionTip = false;

Vue.filter('dateFormatted', (value: string) => moment(value).format('MMM Do, HH:mm'));

new Vue({
  router,
  store,
  vuetify,
   data() {
    return {
      drawer: null,
      snackbar: {
        show: false,
        color: 'success',
        timeout: 6000,
        text: `Hi, I'm a snackbar`,
      },
      uiConfig: {
        modalWidth: '500',
      },
    };
  },
  methods: {
    showSnackbar(text: string, color?: string, timeout?: number) {
      this.snackbar.color = color || 'success';
      this.snackbar.text = text;
      this.snackbar.timeout = timeout || 6000;
      this.snackbar.show = true;
    },
  },
  render: (h) => h(App),
}).$mount('#app');
